import { Search } from 'lucide-react'
import { cn }     from '@utils'

const STATUS_OPTIONS = [
  { value: 'all',      label: 'All Status' },
  { value: 'active',   label: 'Active'     },
  { value: 'inactive', label: 'Inactive'   },
]

const selectCls = cn(
  'h-9 pl-3 pr-8 rounded-xl border text-sm appearance-none cursor-pointer',
  'focus:outline-none focus:ring-2 focus:ring-[var(--ac-secondary)] focus:ring-inset',
  'transition-colors duration-150',
)

export function RoleFilters({ search, status, onSearchChange, onStatusChange }) {
  return (
    <div className="flex flex-col sm:flex-row gap-3">
      {/* Search */}
      <div className="relative flex-1 min-w-0">
        <Search
          size={14} strokeWidth={2}
          className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
          style={{ color: 'var(--ac-text-subtle)' }}
        />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search roles…"
          className="w-full h-9 pl-9 pr-3 rounded-xl border text-sm focus:outline-none focus:ring-2 focus:ring-[var(--ac-secondary)] focus:ring-inset transition-colors duration-150"
          style={{ background: 'var(--ac-bg-surface)', borderColor: 'var(--ac-border-base)', color: 'var(--ac-text-base)' }}
        />
      </div>

      {/* Status */}
      <div className="relative">
        <select
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
          className={selectCls}
          style={{ background: 'var(--ac-bg-surface)', borderColor: 'var(--ac-border-base)', color: 'var(--ac-text-base)' }}
        >
          {STATUS_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
    </div>
  )
}
